var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    clipPath: "url(#clip0_90_801)",
    filter: "url(#filter0_d_90_801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49 35.25C49 35.9405 48.4404 36.5 47.75 36.5C47.0596 36.5 46.5 35.9405 46.5 35.25C46.5 34.5596 47.0596 34 47.75 34C48.4404 34 49 34.5596 49 35.25Z",
    fill: "#2DD4BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.8125 81.5625C52.4238 81.5625 56.8544 80.2529 60.6953 77.7671L80.5624 97.6337C81.0502 98.1215 81.8417 98.122 82.33 97.6337L87.6337 92.33C88.122 91.8418 88.122 91.0507 87.6337 90.5625L67.767 70.6953C70.2529 66.855 71.5624 62.4238 71.5624 57.8125C71.5624 55.7183 71.29 53.646 70.7529 51.6411L75.2753 47.1187C76.0195 47.5591 76.8866 47.8125 77.8124 47.8125C80.5693 47.8125 82.8124 45.5699 82.8124 42.8125C82.8124 40.0557 80.5693 37.8125 77.8124 37.8125C75.0556 37.8125 72.8124 40.0557 72.8124 42.8125C72.8124 43.7388 73.0663 44.6065 73.5073 45.3511L69.8686 48.9898C67.0629 41.9722 61.0039 36.5928 53.6406 34.7247C52.9711 34.5547 52.2915 34.96 52.1215 35.6289C51.9521 36.2984 52.3569 36.9786 53.0258 37.148C59.9663 38.9087 65.6132 44.1563 67.9257 50.9326L61.601 57.2573C60.8564 56.8169 59.9887 56.5625 59.0625 56.5625C58.1547 56.5625 57.2841 56.8037 56.5224 57.2549L52.1181 52.8506C52.5586 52.106 52.8125 51.2388 52.8125 50.3125C52.8125 47.5557 50.5693 45.3125 47.8125 45.3125C45.0556 45.3125 42.8125 47.5557 42.8125 50.3125C42.8125 51.2388 43.0664 52.1065 43.5073 52.8511L39.1011 57.2573C38.3564 56.8169 37.4888 56.5625 36.5625 56.5625C33.8056 56.5625 31.5625 58.8057 31.5625 61.5625C31.5625 64.3198 33.8056 66.5625 36.5625 66.5625C39.3193 66.5625 41.5625 64.3198 41.5625 61.5625C41.5625 60.6372 41.3086 59.77 40.8686 59.0259L45.2754 54.6187C46.02 55.0591 46.8867 55.3125 47.8125 55.3125C48.7382 55.3125 49.6059 55.0586 50.3501 54.6182L54.7544 59.0225C54.3037 59.7842 54.0625 60.6548 54.0625 61.5625C54.0625 64.3198 56.3056 66.5625 59.0625 66.5625C61.8193 66.5625 64.0624 64.3198 64.0624 61.5625C64.0624 60.6372 63.8085 59.77 63.3686 59.0259L68.6694 53.7246C68.9301 55.0654 69.0624 56.4336 69.0624 57.8125C69.0624 69.5483 59.5522 79.0625 47.8125 79.0625C36.0605 79.0625 26.5 69.5298 26.5 57.8125C26.5 48.1006 33.0727 39.6148 42.4839 37.1768C43.1523 37.0035 43.5537 36.3213 43.3803 35.6529C43.207 34.9849 42.5249 34.5831 41.8569 34.7564C31.6992 37.3877 24 46.6568 24 57.8125C24 70.9082 34.6821 81.5625 47.8125 81.5625ZM77.8124 40.3125C79.1908 40.3125 80.3124 41.4341 80.3124 42.8125C80.3124 44.1909 79.1908 45.3125 77.8124 45.3125C76.434 45.3125 75.3124 44.1909 75.3124 42.8125C75.3124 41.4341 76.434 40.3125 77.8124 40.3125ZM36.5625 64.0625C35.1841 64.0625 34.0625 62.9409 34.0625 61.5625C34.0625 60.1841 35.1841 59.0625 36.5625 59.0625C37.9409 59.0625 39.0625 60.1841 39.0625 61.5625C39.0625 62.9409 37.9409 64.0625 36.5625 64.0625ZM45.3125 50.3125C45.3125 48.9341 46.434 47.8125 47.8125 47.8125C49.1909 47.8125 50.3125 48.9341 50.3125 50.3125C50.3125 51.6909 49.1909 52.8125 47.8125 52.8125C46.434 52.8125 45.3125 51.6909 45.3125 50.3125ZM59.0625 64.0625C57.684 64.0625 56.5625 62.9409 56.5625 61.5625C56.5625 60.1821 57.6816 59.0625 59.0625 59.0625C60.4409 59.0625 61.5624 60.1841 61.5624 61.5625C61.5624 62.9409 60.4409 64.0625 59.0625 64.0625ZM81.4462 94.9824L67.5541 81.0898L71.0898 77.5542L84.9818 91.4463L81.4462 94.9824ZM66.2812 72.7451L69.3222 75.7861L65.7861 79.3222L62.7451 76.2812C64.0458 75.229 65.2285 74.0459 66.2812 72.7451Z",
    fill: "#2DD4BF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_801",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.831373 0 0 0 0 0.74902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(24 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.53b4b8ccb237fda64b35377636612ac7.svg";
export { ForwardRef as ReactComponent };